(function(b){function c(){}for(var d="assert,count,debug,dir,dirxml,error,exception,group,groupCollapsed,groupEnd,info,log,timeStamp,profile,profileEnd,time,timeEnd,trace,warn".split(","),a;a=d.pop();){b[a]=b[a]||c}})((function(){try
{console.log();return window.console;}catch(err){return window.console={};}})());

var formatMoney = "$ \{\{amount\}\}";

var isMobile = {
    Android: function() {
        return navigator.userAgent.toLowerCase().match(/android/i);
    },
    BlackBerry: function() {
        return navigator.userAgent.toLowerCase().match(/blackberry/i);
    },
    iOS: function() {
        return navigator.userAgent.toLowerCase().match(/iphone|ipad|ipod/i);
    },
    Opera: function() {
        return navigator.userAgent.toLowerCase().match(/opera mini/i);
    },
    Windows: function() {
        return navigator.userAgent.toLowerCase().match(/iemobile/i);
    },
    any: function() {
        return (isMobile.Android() || isMobile.BlackBerry() || isMobile.iOS() || isMobile.Opera() || isMobile.Windows());
    }
};

jQuery(function($) {
  	if(!isMobile.any()) {
      $('body').addClass('isNotMobile'); 
    }

    $('.content-wrapper').css('padding-top', $('#header').height());

    $(document).on("click", ".quantity .minus", function() {
        var wrapper = $(this).parent();
        try {
          wrapper.find('input[type=number]').get(0).stepDown();
        } catch(e) {
          var value = (parseInt(wrapper.find('input[type=number]').val())-1);
          wrapper.find('input[type=number]').val((value>=1 ? value : 1));
        }
    });
    $(document).on("click", ".quantity .plus", function() {
        var wrapper = $(this).parent();
        try {
          wrapper.find('input[type=number]').get(0).stepUp();
        } catch(e) {
          var value = (parseInt(wrapper.find('input[type=number]').val())+1);
          wrapper.find('input[type=number]').val(value);
        }
    });

    if($('#mini-cart').length > 0) {
        initMiniCart();
    }

    
        $('body').delegate('.add-to-cart-form', 'submit', function(){
            if(validateAddCart($(this))) {
              addToCart($(this));
            }
            return false;
        });
    

    new WOW().init();

    $(window).scroll(function(){
        if($(this).scrollTop()<=200) {
          $('.scrollup').fadeOut();
        } else {
          $('.scrollup').fadeIn();
        }

        if( $(this).scrollTop()>=100 ) {
            $('#header').addClass('scroll');
        } else {
            $('#header').removeClass('scroll');
        }

        if( $(this).scrollTop()>=30 ) {
            $('#top-header').addClass('scroll');
        } else {
            $('#top-header').removeClass('scroll');
        }
    });

    $(window).resize(function(){
        $.fancybox.update();
    });

  
    $("a[rel='fancybox']").fancybox({
      padding: 0,
      margin: [40,30,20,10],
      closeEffect: 'fade',
      autoCenter: true,
      helpers: {
        overlay: { speedOut : 500 }
      }
    });
    
  
  
    $("#search-form-header").on('submit', function(event){
      event.preventDefault();
      window.location.href = '/search?type=product&q=title:' + encodeURI($(this).find('#search-input').val())+'+-tag:no-search';
      return false;
    });
  
  $(document).on('click', ".spr-badge-caption a", function(){
    $("#tab-reviews a").trigger('click');
    $('html, body').animate({
      scrollTop: $("#shopify-product-reviews").offset().top
    }, 1000);
  });
  $(document).on('click', ".btn-read-transcript", function(event){
    event.preventDefault();
    $(".read-transcript").slideToggle("slow");
  });
  
 
  $(document).on('click', '#shopify-product-reviews a', function(event){
    $("#shopify-product-reviews")
    	.css('height','auto')
    	.css('max-height','none')
    	.addClass('open');

    $(".read-more-reviews a").addClass('less').html('READ LESS');
  });
  
  //Comes referrer from Friendbuy
  var discount = getURLParameter('fbuy_value');
  if(discount) {
  	sessionStorage.setItem("discount", discount);
  }
  
  $(document).on('click', '.customer-links--search a', function(event){
    $("#right-header").slideToggle();
  });
});

function validateEmail(email) {
    var re = /^([\w-]+(?:\.[\w-]+)*)@((?:[\w-]+\.)*\w[\w-]{0,66})\.([a-z]{2,6}(?:\.[a-z]{2})?)$/i;
    return re.test(email);
}

function validateAddCart(form) {
  if(form.find('input[name=id]').val()=='') {
        var allOptionsSelected;
        if(form.find('.single-option-selector').length > 0) {
            allOptionsSelected = true;
            form.find('.single-option-selector').each(function(){
                if($(this).val()=="") {
                    allOptionsSelected = false;
                    return false;
                }
            });
        } else {
            allOptionsSelected = false;
        }

        if(allOptionsSelected) {
            var errorMsg = form.find('.validation-msg').text();
            if(errorMsg) {
                alert(errorMsg);
            } else {
                alert("The selected variant is sold out.");
            }
        } else {
            var labels = [];
            form.find('.options label').each(function(key, obj){
                labels.push($(obj).text().replace(':', '').trim());
            });
            alert("You must select a "+labels.join('/')+".");
        }
        return false;
    }
    return true;
}

function initMiniCart() {
    $('#view-cart-normal').click(function(e){
      e.stopPropagation();
      $('#mini-cart').slideToggle();
      return false;
    });

    $(document).click(function(){
      $("#mini-cart").slideUp();
    });

    $('body').delegate('#mini-cart a.remove-from-cart', 'click', function(){
      var variantId = $(this).attr('href').replace('#', '');

      
        removeItemToCart(variantId);
      

      return false;
    });
}

/**
 * Page-specific call-backs
 * Called after dom has loaded.
 */
var RADIANCE = {

    common : {
        init: function(){
            $('html').removeClass('no-js').addClass('js');
            setupDropdownMenus();

            $('.nav-arrow', '#top-menu').each( function(){
                $(this).css('top', Math.ceil($(this).parent(2).height()/2) + 1);
            });

        }
    },

    templateIndex : {
        init: function(){

        }
    },

    templateProduct : {
        init: function(){
            //$('#product-actions').bind( 'submit', addToCart );
            $('#thumbs li:nth-child(5n+5)').addClass('last-in-row');
        }
    },

    templateCart : {
        init: function(){
          var checkGiftNote = function() {
              if($('#chk-is-gift').is(':checked')) {
                  $('#is-gift').val('Yes');
                    $('#gift-note').show();
              } else {
                  $('#is-gift').val('No');
                  $('#gift-note').hide();
                  $('#gift-note').find('textarea').val("");
              }
          }
          $('#chk-is-gift').click(function(){
                checkGiftNote();
          });
          checkGiftNote();
        }
    }

}

/**
 * Fire function based upon attributes on the body tag.
 * This is the reason for "template" in layout/theme.liquid
 *
 * @see http://paulirish.com/2009/markup-based-unobtrusive-comprehensive-dom-ready-execution/
 */
var UTIL = {

    fire : function(func,funcname, args){
        var namespace = RADIANCE;
        funcname = (funcname === undefined) ? 'init' : funcname;
        if (func !== '' && namespace[func] && typeof namespace[func][funcname] == 'function'){
            namespace[func][funcname](args);
        }
    },

    loadEvents : function(){
        var bodyId = document.body.id;

        // hit up common first.
        UTIL.fire('common');

        // do all the classes too.
        $.each(document.body.className.split(/\s+/),function(i,classnm){
            UTIL.fire(classnm);
            UTIL.fire(classnm,bodyId);
        });
    }

};
$(document).ready(UTIL.loadEvents);

/**
 * Support for dropdown menus
 */
function setupDropdownMenus(){
    var $dropDowns = $('#menu-container .has-dropdown');
	var timer;
    
  	
    function navRollOver(e){
      	$dropDowns.removeClass('active').find('.dropdown-container').hide();
        $(this).addClass('active').find('.dropdown-container').show();
      	clearTimeout(timer);
    }
    function navRollOut(e){
      var _this = this;
      timer = setTimeout(function(){
       	$(_this).removeClass('active').find('.dropdown-container').hide();
      }, 700); 
       
    }
  
  	$dropDowns.hoverIntent( navRollOver, navRollOut ); 
}

if ((typeof Shopify) === 'undefined') { Shopify = {}; }
// Get from cart.js returns the cart in JSON
Shopify.getCart = function(callback) {
  jQuery.getJSON('/cart.js', function (cart, textStatus) {
    if ((typeof callback) === 'function') {
      callback(cart);
    }
    else {
      Shopify.onCartUpdate(cart);
    }
  });
};

/**
 * Ajaxy add-to-cart
 */
function addToCart(form){
  //$('body').css('pointer-events','none');
  $('#add-to-cart-button.4484405133377').attr('disabled',true).addClass('disabled');
    //$('#add-cart-overlay').fadeIn();
	
  	
    $.ajax({
        type: 'POST',
        url: '/cart/add.js',
        //async: false,
        data: form.serialize(),
        dataType: 'json',
        error: addToCartFail,
        success: addToCartSuccess,
        cache: false
    });
}

function addToCartSuccess(jqXHR, textStatus, errorThrown){
    Shopify.getCart(function(cart) {
      updateCartDesc();
    });
    /*$.ajax({
        type: 'GET',
        url: '/cart.js',
        async: false,
        cache: false,
        dataType: 'json',
        success: updateCartDesc
    });*/
    
    
    setTimeout(function(){ 
      //$('body').css('pointer-events',''); 
      //$('#add-to-cart-button').attr('disabled',false).removeClass('disabled');
      $('#add-cart-overlay').fadeOut();
    }, 1000);
  	
	/*
    $.fancybox(
        $("<div />").append($("#item-added").clone().show()).html(),
            {
              'overlayColor' : '#000',
              "overlayOpacity": 0.5
            }
    );
    */
}

function addToCartFail(jqXHR, textStatus, errorThrown){
    var response = $.parseJSON(jqXHR.responseText);
    //$('#add-to-cart-msg').addClass('error').text(response.description).fadeIn('fast');
    $('#add-cart-overlay').fadeOut();

    if (iStockInit == undefined){
      iStockInit = function(){};	
    }
    //var popup = $("#item-added").clone().addClass('error').show();
  	showSoldOutMessageCallback(response.description);
}

function showSoldOutMessageCallback(description){
  var popup = $("#item-added");
  var outOfstockform = $('#iStock-wrapper');
  outOfstockform.find('h2').hide();
    popup.find('.buttons').hide();
	popup.append(outOfstockform);
  	popup.find('.msg').show().html('- '+ description +' -');
    
   //$.fancybox($("<div />").append(popup).html(), {
    $.fancybox(popup, {
        'overlayColor' : '#000',
        "overlayOpacity": 0.5,
    });
}


function removeItemToCart(variantId){
    $('#add-cart-overlay').fadeIn();

    $('#mini-cart').remove();
    $.ajax({
        type: 'POST',
        url: '/cart/change.js',
        data: {
          id: variantId,
          quantity: 0
        },
        dataType: 'json',
        error: function(){
            Shopify.getCart(function(cart) {
              updateCartDesc();
            });
            $('#add-cart-overlay').fadeOut();
        },
        success: function(){
            Shopify.getCart(function(cart) {
              updateCartDesc();
            });
            $('#add-cart-overlay').fadeOut();
        },
        cache: false
    });
}

function updateCartDesc(){
    
}

function toogleTab(tab){
  //event.preventDefault();
  $('#'+tab).show();

  switch(tab){
    case 'prod-why-it-works':
        $('#prod-ingredients.tabbed--tab').hide();
        $('#reviews.tabbed--tab').hide();
        $('#prod-directions.tabbed--tab').hide();
      	$('#prod-qa.tabbed--tab').hide();

        $('#tab-prod-ingredients').removeClass("ui-state-active");
        $('#tab-reviews').removeClass("ui-state-active");
        $('#tab-prod-directions').removeClass("ui-state-active");
      	$('#tab-prod-qa').removeClass("ui-state-active");
        break;

    case 'prod-ingredients':
        $('#prod-why-it-works.tabbed--tab').hide();
        $('#reviews.tabbed--tab').hide();
        $('#prod-directions.tabbed--tab').hide();
      	$('#prod-qa.tabbed--tab').hide();

        $('#tab-prod-why-it-works').removeClass("ui-state-active");
        $('#tab-reviews').removeClass("ui-state-active");
        $('#tab-prod-directions').removeClass("ui-state-active");
      	$('#tab-prod-qa').removeClass("ui-state-active");
        break;

    case 'reviews':
        $('#prod-why-it-works.tabbed--tab').hide();
        $('#prod-ingredients.tabbed--tab').hide();
        $('#prod-directions.tabbed--tab').hide();
      	$('#prod-qa.tabbed--tab').hide();

        $('#tab-prod-ingredients').removeClass("ui-state-active");
        $('#tab-prod-why-it-works').removeClass("ui-state-active");
        $('#tab-prod-directions').removeClass("ui-state-active");
      	$('#tab-prod-qa').removeClass("ui-state-active");
        break

    case 'prod-directions':
        $('#prod-why-it-works.tabbed--tab').hide();
        $('#prod-ingredients.tabbed--tab').hide();
        $('#reviews.tabbed--tab').hide();
      	$('#prod-qa.tabbed--tab').hide();

        $('#tab-prod-ingredients').removeClass("ui-state-active");
        $('#tab-reviews').removeClass("ui-state-active");
        $('#tab-prod-why-it-works').removeClass("ui-state-active");
      	$('#tab-prod-qa').removeClass("ui-state-active");
        break;
     
    case 'prod-qa':
        $('#prod-why-it-works.tabbed--tab').hide();
        $('#prod-ingredients.tabbed--tab').hide();
        $('#reviews.tabbed--tab').hide();
      	$('#prod-directions.tabbed--tab').hide();

        $('#tab-prod-ingredients').removeClass("ui-state-active");
        $('#tab-reviews').removeClass("ui-state-active");
        $('#tab-prod-why-it-works').removeClass("ui-state-active");
      	$('#tab-prod-directions').removeClass("ui-state-active");
        break;
      
  }

  $('#tab-'+tab).addClass("ui-state-active");
  return false;
}

function getURLParameter(name) {
  return decodeURIComponent((new RegExp('[?|&]' + name + '=' + '([^&;]+?)(&|#|;|$)').exec(location.search)||[,""])[1].replace(/\+/g, '%20'))||null;
}